export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: { frequency: 'one time', estCost: null, currency: 'USD' },
    totalRecurringCost: { frequency: 'monthly', estCost: null, currency: 'USD' },
    notes: '',
};

export const DEFAULT_QUEUE_TYPE = 'Standard';

export const resetOrder = {
    applicationName: null,
    appShortName: null,
    appProfile: null,
    appProfileDetails: null,
    entityDetails: null,
    appTier: null,
    appTierCode: null,
    sector: null,
    sectorDetail: null,
    department: null,
    departmentDetail: null,
    selectedDepartmentOption: null,
    appRegion: null,
    appRegionDetail: null,
    selectedAppRegionOption: null,
    environment: null,
    envShortName: null,
    region: null,
    selectedRegionOption: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    isValidCostCenter: false,
    enabledManualBudgetCode: false,
    appOwner: null,
    appOwnerDetails: null,
    awsAccount: null,
    awsAccountId: null,
    queueType: DEFAULT_QUEUE_TYPE,
    queueName: null,
    tags: [],
    estimatedCost: resetCostEstimateDetails,
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    emptyCost: null,
    timeZone: 'UTC',
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

const formOrder = (catalogService, entityDetails) => {
    const config = catalogService?.catalogConfig || {};
    const environment = config?.environmentDetails || {};
    const owner = entityDetails || {};
    const appOwner = owner?.applicationManagerGpid ? `${owner?.applicationManagerGpid} - ${owner?.applicationManager}` : null;
    return {
        ...resetOrder,
        appProfile: owner?.name || config?.tags?.Application || config?.applicationService || null,
        appProfileDetails: {
            label: owner?.name || config?.tags?.Application || config?.applicationService,
            data: { businessApplicationName: owner?.businessCi || config?.tags?.BusinessService },
        },
        applicationName: config?.applicationName || null,
        appShortName: config?.appShortName || null,
        appTier: environment?.applicationTier || null,
        appTierCode: environment?.appTierCode || null,
        sector: catalogService?.sector || owner?.sector || environment?.sector || null,
        department: environment?.department || config?.department || null,
        appRegion: environment?.applicationRegion || null,
        environment: environment?.environment || null,
        envShortName: environment?.backendEnvironment || null,
        region: environment?.region || null,
        hCode: config?.costCenter || environment?.costCenter || null,
        hCodeDetails: config?.costCenter || environment?.costCenter ? { label: config?.costCenter || environment?.costCenter } : null,
        enabledManualBudgetCode: config?.enabledManualBudgetCode === true,
        isValidCostCenter: true,
        appOwner,
        appOwnerDetails: { label: appOwner, gpid: owner?.applicationManagerGpid, name: owner?.applicationManager, email: owner?.applicationManagerEmail },
        awsAccount: config?.accountName || null,
        awsAccountId: config?.accountId || config?.awsAccountId || null,
        queueType: config?.awsQueueType || config?.queueType || DEFAULT_QUEUE_TYPE,
        queueName: config?.awsQueueName || config?.queueName || null,
        timeZone: catalogService?.timeZone || 'UTC',
        entityDetails: owner,
        catalogCode: catalogService?.catalogServiceCode,
        catalogType: catalogService?.catalogType,
        cloudProvider: catalogService?.cloudProvider,
        cloudService: catalogService?.cloudService,
        estimatedCost: catalogService?.estimatedCost || resetCostEstimateDetails,
    };
};

export const costPayload = ({ order = {}, catalogCode }) => ({
    catalogServiceCode: catalogCode,
    quantity: 1,
    catalogConfig: {
        queueType: order?.queueType,
    },
});

export const formOrderObjFromCart = (data) => formOrder(data?.itemDetail?.catalogService, data?.itemDetail?.entityDetails);

export const formOrderObjFromOrderDetails = (catalogServiceId, data) =>
    formOrder(
        data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId),
        data?.entityDetails || data?.itemDetail?.entityDetails
    );
